import { useSelector } from 'react-redux';
import store from '../../store';

/**
 * Returns ALL tenant features as a parsed object with camelCase keys.
 * Booleans auto-parsed: { isExamineticsEnabled: true, isAthleteEnabled: false }
 *
 * Usage in functional components:
 *   const { isExamineticsEnabled, isAthleteEnabled } = useTenantFeatures();
 */
export const useTenantFeatures = () => {
    return useSelector(state => state.tenantFeatures.features);
};

/**
 * Direct store access for non-hook contexts (class components, services).
 * Returns the same parsed object.
 *
 * Usage: const { isExamineticsEnabled } = getTenantFeatures();
 */
export const getTenantFeatures = () => {
    return store.getState().tenantFeatures.features;
};
